import Pic1 from '../assets/images/pages/1_DSC00770.webp';
import Pic2 from '../assets/images/pages/2_DSC01398.webp';
import Pic4 from '../assets/images/pages/4_DSC00054.webp';
import PhotoBoardPage from '../pages/PhotoBoardPage';
import SchedulePage from '../pages/SchedulePage';
import DayFullPage from '../pages/DayFullPage';
import Story from '../story-components/Story';

export default function DayPage({ type }) {
  const titleKey = type === 'morning' ? 'home.morning_title' : 'home.evening_title';

  const dayPages = [
    {
      id: 1,
      titleKey,
      key: 'home',
      image: Pic1,
      component: <DayFullPage image={Pic1} titleKey={titleKey} />,
      hideImage: true,
    },
    {
      id: 2,
      titleKey: 'nav.photoboard',
      key: 'photoboard',
      image: Pic4,
      component: <PhotoBoardPage eventType={type} />,
    },
    {
      id: 3,
      titleKey: 'nav.schedule',
      subtitleKey: 'nav.schedule_subtitle',
      key: 'schedule',
      image: Pic2,
      component: <SchedulePage type={type} />,
    },
  ];

  return (
    <div className="w-screen h-[100dvh] overflow-hidden fixed inset-0">
      <Story guestDetails={{}} pages={dayPages} />
    </div>
  );
}
